import { DELETE_PRODUCT_CURRENCY } from "../../types/ProductCurrencyType";
import axios from "axios";

const deleteProductCurrency = (id) => {
	return {
		type: DELETE_PRODUCT_CURRENCY,
		payload: id,
	};
};

export const DeleteProductCurrency = (id) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			await axios({
				method: "patch",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `product-currency/${id}`,
				data: {
					status: false,
				},
			});
			//dispatching data
			dispatch(deleteProductCurrency(id));
		} catch (error) {
			console.log(error.message);
		}
	};
};
